import { Select } from "@mantine/core";

export type EventSortOption =
  | "startTime-asc"
  | "startTime-desc"
  | "createdAt-asc"
  | "createdAt-desc";

interface EventSortProps {
  value: EventSortOption;
  onChange: (value: EventSortOption) => void;
}

export const EventSort = ({ value, onChange }: EventSortProps) => {
  return (
    <Select
      label="정렬"
      value={value}
      onChange={(val) => {
        if (val) onChange(val as EventSortOption);
      }}
      data={[
        { value: "startTime-asc", label: "이벤트 날짜 (가까운 순)" },
        { value: "startTime-desc", label: "이벤트 날짜 (먼 순)" },
        { value: "createdAt-desc", label: "생성일 (최신 순)" },
        { value: "createdAt-asc", label: "생성일 (오래된 순)" },
      ]}
      styles={{
        label: { color: "black" },
        input: { color: "black" },
        option: { color: "black" },
        dropdown: { backgroundColor: "white" },
      }}
    />
  );
};
